import { Text, Box, TableContainer, Flex, Table, useToken } from "@chakra-ui/react";
import React, { Fragment, useState } from "react";
import PrimaryButton from "../../components/themeComponents/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { getExitIntent } from "../../Services/api";
import { OvalSpinner } from "../../components/Loaders";
import TableHead from "../Campaigns/components/TableHead";
import { prepareExitIntentData } from "../../_helpers/data_helper";
import hexToRgba from "hex-to-rgba";
import OutlinedButton from "../../components/themeComponents/OutlinedButton";
import ExitIntentFilter from "./ExitIntentFilter";
import ExitIntentTable from "./ExitIntentTable";
import Pagination from "../../components/Pagination"; // Import the generic Pagination component

function ExitIntentList() {
  const navigate = useNavigate();
  const [mainColor] = useToken("colors", ["primary.main"]);
  const [totalCount, setTotalCount] = useState(0);
  const [campaignFilter, setCampaignFilter] = useState({ keyword: "", status: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const exitIntentQuery = useQuery(
    ["exitIntentList", currentPage, campaignFilter],
    async () => {
      const res = await getExitIntent(campaignFilter.keyword, currentPage, campaignFilter.status);
      setTotalCount(res?.data?.count ?? 0);
      return prepareExitIntentData(res.data) ?? [];
    },
    {
      staleTime: 0, // Ensure fresh data on page change
      retry: 1,
      enabled: true, // Always enabled
    }
  );

  return (
    <Fragment>
      <Box h="100%" overflow="hidden" display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
          <Text fontSize="xl" as="b">
            Exit Intent
          </Text>
          <OutlinedButton
            mb="5px"
            label="Create Campaign"
            onClick={() => navigate("/exit-intent-create")}
          />
        </Box>
        <ExitIntentFilter
          onFilter={(dt) => {
            setCampaignFilter(dt);
            setCurrentPage(1); // Reset to first page on filter change
          }}
        />
        <TableContainer bg="white" position="relative" p={3} overflowY="auto">
          {exitIntentQuery.isLoading && (
            <Flex justifyContent="center" alignItems="center" h="200px">
              <OvalSpinner width={50} height={50} />
            </Flex>
          )}
          {!exitIntentQuery.isLoading && exitIntentQuery.isError && (
            <Flex justifyContent="center" alignItems="center" py={10}>
              <Text color="red.500">Error loading campaigns. Please try again.</Text>
            </Flex>
          )}
          {!exitIntentQuery.isLoading && !exitIntentQuery.isError && (
            <Table>
              {exitIntentQuery.data?.length > 0 ? (
                <Fragment>
                  <TableHead
                    zIndex="999"
                    headersProps={["Name", "CreatedAt", "UpdatedAt", "Actions"]}
                  />
                  <ExitIntentTable
                    list={exitIntentQuery.data}
                    refetch={() => exitIntentQuery.refetch()}
                  />
                </Fragment>
              ) : (
                <Flex direction="column" justifyContent="center" alignItems="center" py={10}>
                  <Text fontSize="lg" fontWeight="bold" color="gray.600">
                    No campaigns found for the selected filters.
                  </Text>
                  <PrimaryButton
                    label="Create Campaign Now"
                    mt={4}
                    onClick={() => navigate("/exit-intent-create")}
                    size="md"
                  />
                </Flex>
              )}
            </Table>
          )}
          {!exitIntentQuery.isLoading && exitIntentQuery?.data?.length > 0 && (
            <Pagination
              totalCount={totalCount}
              currentPage={currentPage}
              pageSize={pageSize}
              onPageChange={setCurrentPage}
              isDisabled={exitIntentQuery.isLoading}
            />
          )}
        </TableContainer>
      </Box>
    </Fragment>
  );
}

export default ExitIntentList;